import React, { useMemo } from 'react'
import { AdminRoot } from '@fs/zion-root'
import { AppLayout } from '@fs/zion-ui'
import useToolsPermission from '../../hooks/useToolsPermission'
import { SECTIONS } from './toolCatalog'
import portalHeaderNav from './portalHeaderNav'

// AdminHeader always renders a lang picker; a component returning null is the only way to drop it.
const NoLangPicker = () => null

// Everything between the router and the app: AdminRoot and its AdminHeader config. It sits inside the
// Router because AdminHeader renders router links and reads the current path to mark the active one.
export default function PortalChrome({ children }) {
  const { hasToolsPermission } = useToolsPermission()
  const sections = SECTIONS

  const header = useMemo(
    () => ({
      appName: 'ADE Portal',
      baseUrl: '/',
      helpButtonProps: null,
      LangPicker: NoLangPicker,
      mobileDrawerBreakpoint: 'xl',
      nav: hasToolsPermission ? portalHeaderNav(sections) : [],
    }),
    [hasToolsPermission, sections]
  )

  return (
    <AdminRoot analytics header={header}>
      <AppLayout fullWidth>{children}</AppLayout>
    </AdminRoot>
  )
}
